'use client';

import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocale } from '@/hooks/use-locale';

/**
 * `t` bound to the URL locale rather than the shared i18next language.
 *
 * I18nProvider switches that language in an effect, which never runs on the
 * server, so plain `useTranslation` renders German into /en HTML and the text
 * changes after hydration. de and en are bundled up front, so a fixed `t`
 * gives the same language on the server and the client.
 */
export function useLocaleTranslation() {
  const { locale } = useLocale();
  const { i18n } = useTranslation();
  const t = useMemo(() => i18n.getFixedT(locale), [i18n, locale]);
  return { t, locale };
}
